<template>
  <div class="root">
    <div>
      <div class="flex">
        <input
          ref="searchField"
          :value="searchTerm"
          @input="(evt) => (searchTerm = evt.target.value)"
          type="text"
          @keyup="doSearch"
          placeholder="Search for an item in a RUX..."
          class="form-control"
        />
        <i @click="handleClick" class="material-symbols-outlined cancel-button pointer"
          >cancel_presentation</i
        >
      </div>
      <div class="relative">
        <div v-if="searchTerm.length > 2" class="flex">
          <NavigationRuxList
            v-if="this.searchComplete"
            class="search-results"
            :items="searchResults"
            :showAll="false"
            :handleClick="tidyUpSearch"
            :showImage="false"
          />
          <!--<div v-if='searchComplete && searchResults.length === 0'>Nothing found</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationRuxList from './NavigationRuxList'
export default {
  name: 'Search',
  props: ['handleClick'],
  components: { NavigationRuxList },
  data: function () {
    return {
      searchTerm: '',
      searchData: [],
      searchResults: [],
      searchComplete: false,
    }
  },
  mounted() {
    this.$refs.searchField.focus()
    this.getData()
  },
  methods: {
    getData() {
      // This could be a getter in the store rather than having logic here. At least the searchData variable could be.
      // Might be better to leave the specifcs here.
      this.searchData = this.$store.state.rux.ruxList.reduce((acc, rix) => {
        return acc.concat(
          rix.packingListItems.map((item) => {
            return {
              item,
              shortDescription: rix.shortDescription,
              serialNumber: rix.serialNumber,
            }
          })
        )
      }, [])
    },
    doSearch() {
      this.searchComplete = false
      if (this.searchTerm.length > 2) {
        this.searchResults = this.searchData
          .filter((val) => {
            console.log(val)
            return (
              val.item.value.toString().toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
            )
          })
          .map((val) => {
            return {
              value: val.item.value + ' found in ' + 'RUX ' + '"' + val.shortDescription + '"',
              serialNumber: val.serialNumber,
            }
          })
        this.searchComplete = true
      } else {
        this.searchResults = []
      }
    },
    tidyUpSearch() {
      this.handleClick()
      this.searchResults = []
      this.searchTerm = null
    },
  },
}
</script>

<style lang='scss' scoped>
.relative {
  position: relative;
}
.search-results {
  position: absolute;
  width: 95%;
  max-width: 568px;
  margin-right: 20px;
}
input {
  max-width: 568px;
  height: 45px;
}
.cancel-button {
  position: relative;
  top: 10.5px;
  left: 7px;
}
.flex {
  display: flex;
  justify-content: center;
}
</style>